// JS
import React, { useState, useEffect } from 'react';
import UseFetchPost from '../shared/useFetchPost';
import { brandsAllFeed } from '../shared/jsonData';
import { groupArrayTo, randomId } from '../shared/utils';
import { Skeleton } from '../Ui/skeleton';

// COMPONENT
const BrandList = ({ gaBlockName, blackFriday, brandListOptions }) => {
  const uniqueId = randomId();
  var alphabet = '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  var [brandCount, setBrandCount] = useState(0);
  const [brands, setBrands] = useState([]);
  const [active, setActive] = useState(null);

  // GET DATA FROM NQ
  const getData = UseFetchPost(
    brandsAllFeed.endPointUrl,
    brandsAllFeed.endPointPrams
  );

  useEffect(() => {
    if (getData && getData.hierarchy) {
      var count = 0;
      var brandsArr = {};
      getData.hierarchy.forEach((brand) => {
        if (brand?.data?.total < 1) return;

        var letter = brand.name.substring(0, 1).toUpperCase();
        if (!isNaN(letter)) letter = '#';
        if (!(letter in brandsArr)) brandsArr[letter] = [];

        brandsArr[letter].push(brand);
        count++;
      });
      setBrands(brandsArr);
      setBrandCount(count);
    }
  }, [getData]);

  const handleLetterClick = (letter) => {
    if (letter in brands) {
      setActive(letter);
    }
  };

  return (
    <section
      id={'brand-list-' + uniqueId}
      className={
        `container ${blackFriday ? 'my-32' : 'my-32 lg:my-56 w-100'}` +
        (brandListOptions?.classes ? ' ' + brandListOptions.classes : '')
      }
    >
      {getData ? (
        <div
          data-name={'Brands'}
          data-creative={gaBlockName}
          data-id={'brands-' + uniqueId}
          data-position={'banner-slot-1'}
          data-type="banner"
        >
          <h2 className="text-xl text-center font-semibold uppercase tracking-widest md:text-left mb-12">
            Brands <span className="font-base">({brandCount})</span>
          </h2>
          <div className="scroll-none flex items-center justify-between overflow-x-auto -mx-6 px-6">
            {alphabet.map((letter, index) => (
              <div
                key={index}
                className={
                  'text-2xl px-4 first:pl-0 ' +
                  (active === letter
                    ? 'cursor-default text-black font-semibold'
                    : letter in brands
                    ? 'cursor-pointer text-gray-400 hover:text-gray-600'
                    : 'cursor-default text-gray-300')
                }
                onClick={() => handleLetterClick(letter)}
                data-name={letter}
                data-creative={gaBlockName}
                data-id={'brand-' + letter}
                data-position={'button-slot-' + (index + 1)}
                data-type="banner-button"
              >
                {letter}
              </div>
            ))}
            <a
              className={
                'text-xl pl-4 cursor-pointer text-gray-400 hover:text-gray-600 font-semibold ml-4 lg:ml-20'
              }
              href="/brands/"
              data-name={'All'}
              data-creative={gaBlockName}
              data-id={'brand-all'}
              data-position={'button-slot-all'}
              data-type="banner-button"
            >
              ALL
            </a>
          </div>
          {active in brands && (
            <div className="mt-8 lg:mt-12">
              {groupArrayTo(4, brands[active]).map((group, i) => (
                <div
                  key={'parent-' + i}
                  className="flex flex-col lg:flex-row mb-4 last:mb-0 lg:mb-5"
                >
                  {group.map((brand, j) => (
                    <a
                      href={brand.data.url}
                      key={'brand-' + j}
                      className="relative font-semibold mb-4 last:mb-0 lg:mb-0 lg:hover:underline lg:px-8 lg:first:pl-0 lg:last:pr-0 lg:after:block lg:after:absolute lg:last:after:hidden lg:after:top-1/2 lg:after:-translate-y-1/2 lg:after:right-0 lg:after:h-[10px] lg:after:w-[2px] lg:after:bg-gray-300"
                      data-name={brand.name}
                      data-creative={gaBlockName}
                      data-id={brand.code}
                      data-position={'button-slot-' + (i * 4 + j + 1)}
                      data-type="banner-button"
                    >
                      {brand.name}
                    </a>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div>
          <Skeleton className="aspect-square w-80 h-20" />
          <Skeleton className="aspect-square w-[100%] h-[65px] mt-4" />
        </div>
      )}
    </section>
  );
};

export default BrandList;
